import { render } from "./SubmissionContent.vue?vue&type=template&id=30056a34&lang=true"
import script from "./SubmissionContent.vue?vue&type=script&lang=js"
export * from "./SubmissionContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__